package com.ai.mitra.data.mapper

import com.ai.mitra.data.models.CandidateDto
import com.ai.mitra.data.models.ContentDto
import com.ai.mitra.data.models.GeminiResponseDto
import com.ai.mitra.data.models.PartDto
import com.ai.mitra.domain.model.Gemini


fun GeminiResponseDto.toGemini(): Gemini {
    return Gemini(candidates.map { it.toCandidate() })
}

fun CandidateDto.toCandidate(): Gemini.Candidate {
    return Gemini.Candidate(content.toContent())
}

fun ContentDto.toContent(): Gemini.Content {
    return Gemini.Content(parts.map { it.toPart() }, role)
}

fun PartDto.toPart(): Gemini.Part {
    return Gemini.Part(text)
}

